import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { axiosGetData } from "@shared/api/clients";
import { getOperationalModuleSlug } from "@shared/api/server/gs3Server";

import type { GeneralStructureDashboard } from "./generalDashboard.types";

const GENERAL_DASHBOARD_QUERY_KEY = "general-structure-dashboard";

export const getGeneralStructureDashboard = async (
  structureId: string,
): Promise<GeneralStructureDashboard> =>
  axiosGetData<GeneralStructureDashboard>(
    `v1/general/structures/${structureId}/dashboard`,
  );

export const generalStructureDashboardQueryOptions = (structureId: string) => ({
  queryKey: [GENERAL_DASHBOARD_QUERY_KEY, structureId],
  queryFn: () => getGeneralStructureDashboard(structureId),
});

export const useGeneralStructureDashboardQuery = (
  structureId: string | undefined,
  options?: Partial<UseQueryOptions<GeneralStructureDashboard, AxiosError>>,
) =>
  useQuery<GeneralStructureDashboard, AxiosError>({
    ...generalStructureDashboardQueryOptions(structureId ?? ""),
    enabled: Boolean(structureId),
    ...options,
  });

export const generalModuleSlug = () => getOperationalModuleSlug("General");
